export default __webpack_public_path__ + "static/media/pos-resturent.9f8d9bc9.jpeg";